// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts,import_extension="
// @generated from file aiChat.proto (package aiChat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {
  SendMessageRequest,
  SendMessageResponse,
  StartAiChatSessionRequest,
  StartAiChatSessionResponse,
  SubscribeAiChatEventByIdRequest,
  SubscribeAiChatEventByIdResponse,
  SubscribeAiChatEventsRequest,
  SubscribeAiChatEventsResponse,
  SubscribeAiChatSessionRequest,
  SubscribeAiChatSessionResponse,
  UpdateClientInfoRequest,
  UpdateClientInfoResponse,
} from './aiChat_pb'
import { MethodKind } from '@bufbuild/protobuf'

/**
 * @generated from service aiChat.v1.AiChatService
 */
export const AiChatService = {
  typeName: 'aiChat.v1.AiChatService',
  methods: {
    /**
     * セッション開始
     *
     * @generated from rpc aiChat.v1.AiChatService.StartAiChatSession
     */
    startAiChatSession: {
      name: 'StartAiChatSession',
      I: StartAiChatSessionRequest,
      O: StartAiChatSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * メッセージ送信（ユーザー→AI）
     *
     * @generated from rpc aiChat.v1.AiChatService.SendMessage
     */
    sendMessage: {
      name: 'SendMessage',
      I: SendMessageRequest,
      O: SendMessageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * リアルタイム購読（イベントストリーミング）
     *
     * @generated from rpc aiChat.v1.AiChatService.SubscribeAiChatEvents
     */
    subscribeAiChatEvents: {
      name: 'SubscribeAiChatEvents',
      I: SubscribeAiChatEventsRequest,
      O: SubscribeAiChatEventsResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * リアルタイム購読（単一イベントストリーミング）
     *
     * @generated from rpc aiChat.v1.AiChatService.SubscribeAiChatEventById
     */
    subscribeAiChatEventById: {
      name: 'SubscribeAiChatEventById',
      I: SubscribeAiChatEventByIdRequest,
      O: SubscribeAiChatEventByIdResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * リアルタイム購読（セッションストリーミング）
     *
     * @generated from rpc aiChat.v1.AiChatService.SubscribeAiChatSession
     */
    subscribeAiChatSession: {
      name: 'SubscribeAiChatSession',
      I: SubscribeAiChatSessionRequest,
      O: SubscribeAiChatSessionResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * クライアント情報更新
     *
     * @generated from rpc aiChat.v1.AiChatService.UpdateClientInfo
     */
    updateClientInfo: {
      name: 'UpdateClientInfo',
      I: UpdateClientInfoRequest,
      O: UpdateClientInfoResponse,
      kind: MethodKind.Unary,
    },
  },
} as const
